import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Mailaddresses } from './mailaddresses.class';
import { Fetch } from '../fetch.class';
import Upgrademodal from './upgrademodal.class';

export class Page {

    constructor() {

        // --- Passwort

        // Elemente
        this.$btnEditPassword = document.querySelector('button.password');
        this.$inputPasswordCurrent = document.querySelector('#modal-edit-password input[name=password_current]');
        this.$inputPasswordNew = document.querySelector('#modal-edit-password input[name=password_new]');
        this.$formEditPassword = document.querySelector('#modal-edit-password form');
        this.$errorboxEditPassword = document.querySelector('#modal-edit-password .errorbox');

        // Modal
        this.modalEditPassword = new Modal('#modal-edit-password');

        // Modaldialog öffnen
        this.$btnEditPassword.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditPassword.classList.add('hidden');

            // Modal öffnen
            this.modalEditPassword.show();
        });

        // Speicherung
        this.$formEditPassword.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("password_current", this.$inputPasswordCurrent.value);
            data.append("password_new", this.$inputPasswordNew.value);

            // Fehler ausblenden
            this.$errorboxEditPassword.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('profile', 'save_password'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditPassword.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditPassword.querySelector('.cont').textContent = error.message;
                this.$errorboxEditPassword.classList.remove('hidden');
            });
        });

        // --- Empfängeradressen
        const mailaddresses = new Mailaddresses('#mailaddresses', 'account');


        // --- Zeitzone

        // Elemente
        this.$btnEditTimezone = document.querySelector('button.timezone');
        this.$inputEditTimezone = document.querySelector('#modal-edit-timezone select');
        this.$displayTimezone = document.querySelector('#value_timezone');
        this.$formEditTimezone = document.querySelector('#modal-edit-timezone form');
        this.$errorboxEditTimezone = document.querySelector('#modal-edit-timezone .errorbox');

        // Modal
        this.modalEditTimezone = new Modal('#modal-edit-timezone');

        // Modaldialog öffnen
        this.$btnEditTimezone.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditTimezone.classList.add('hidden');

            // Auswahl übernehmen
            this.$inputEditTimezone.value = this.$displayTimezone.textContent;

            // Modal öffnen
            this.modalEditTimezone.show();
        });

        // Speicherung
        this.$formEditTimezone.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("timezone", this.$inputEditTimezone.value);

            // Fehler ausblenden
            this.$errorboxEditTimezone.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('profile', 'save_timezone'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditTimezone.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayTimezone.textContent = this.$inputEditTimezone.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditTimezone.querySelector('.cont').textContent = error.message;
                this.$errorboxEditTimezone.classList.remove('hidden');
            });
        });

        // --- Option: Newsletter
        document.querySelector('#switch_newsletter').addEventListener('change', event => {
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();

            const data = new FormData();
            data.append("use_newsletter", value);

            // Senden
            new Fetch().post(App.getUrl('profile', 'save_usenewsletter'), data)
            .then(response => {

                // Erfolgsmeldung
                new Notification().success(response.msg);
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);

                // Switch zurücksetzen
                switchInstance.undo();
            });
        });

        // --- Account löschen
        this.$btnDeleteAccount = document.querySelector('button.delete-account');
        if(this.$btnDeleteAccount) {

            // Elemente
            this.$inputPasswordDeleteAccount = document.querySelector('#modal-delete-account input[name=password]');
            this.$formDeleteAccount = document.querySelector('#modal-delete-account form');
            this.$errorboxDeleteAccount = document.querySelector('#modal-delete-account .errorbox');

            // Modal
            this.modalDeleteAccount = new Modal('#modal-delete-account');

            // Modaldialog öffnen
            this.$btnDeleteAccount.addEventListener('click', event => {

                // Fehlermeldung ausblenden
                this.$errorboxDeleteAccount.classList.add('hidden');

                // Modal öffnen
                this.modalDeleteAccount.show();
            });

            // Löschung ausführen
            this.$formDeleteAccount.addEventListener('submit', event => {

                event.preventDefault();

                const data = new FormData();
                data.append("password", this.$inputPasswordDeleteAccount.value);

                // Fehler ausblenden
                this.$errorboxDeleteAccount.classList.add('hidden');

                // Senden
                new Fetch().post(App.getUrl('profile', 'delete_account'), data)
                .then(response => {

                    // Modal schliessen
                    this.modalDeleteAccount.close();

                    // Weiterleitung zur Startseite
                    App.gotoUrl("https://form.taxi");
                })
                .catch(error => {

                    // Fehlermeldung anzeigen
                    this.$errorboxDeleteAccount.querySelector('.cont').textContent = error.message;
                    this.$errorboxDeleteAccount.classList.remove('hidden');
                });
            });
        }

        // --- Upgrade
        document.getElementById('wrapper').addEventListener('click', event => {
            if (event.target) {

                // Email Adressen
                const $btnUpgrade = event.target.closest('a.upgrade_mailaddresses');
                if($btnUpgrade) {
                    event.preventDefault();

                    // Modal zur neuen Empfängeradresse schliessen
                    mailaddresses.closeModal();

                    // Upgrade
                    const successMsg = $btnUpgrade.dataset.successmsg ?? '';
                    Upgrademodal.open(
                        () => {

                            // Erfolgsmeldung
                            new Notification().success("Upgrade", successMsg);
                        },
                        "mailaddresses"
                    );
                }
            }
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('profile')) {
        new Page();
    }
});